import React from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { ArrowBack } from "@material-ui/icons";
import {
  soothe_pass_subscriptions,
  updateSoothePassPaymentMethod,
} from "../Shared/Helpers";
import SuccessModal from "../Shared/SuccessModal";
import ErrorModal from "../Shared/ErrorModal";
import LoadingOverlay from "../Shared/LoadingOverlay";

class ChangePlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPlan: null,
      subscriptionPlans: [],
      isUpdatingPlan: false,
      showSuccessModal: false,
      successMessage: "",
      showErrorModal: false,
      error: "",
      loading: true,
      width: window.innerWidth,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", () => {
      this.setState({ width: window.innerWidth });
    });
    this.loadSubscriptionPlans();
  }

  loadSubscriptionPlans = () => {
    const cityId = get(this.props, "client.soothe_pass.city_id");
    if (!cityId) {
      this.setState({
        loading: false,
        error: "No city information available",
        showErrorModal: true,
      });
      return;
    }

    this.setState({ loading: true });
    soothe_pass_subscriptions(
      { city_id: cityId }, // Using city_id instead of zip_code as requested
      (response) => {
        const plans = get(response, "data.subscription_tiers", []);
        this.setState({
          subscriptionPlans: plans,
          loading: false,
        });
      },
      (error) => {
        this.setState({
          loading: false,
          error: get(
            error,
            "response.data.errors.0.message",
            "Failed to load subscription plans"
          ),
          showErrorModal: true,
        });
      }
    );
  };

  handlePlanSelect = (plan) => {
    this.setState({ selectedPlan: plan });
  };

  handleUpdatePlan = () => {
    const { selectedPlan } = this.state;
    if (!selectedPlan) return;

    const clientId = get(this.props, "client.user_id");
    const subscriptionId = get(
      this.props,
      "client.soothe_pass.soothe_pass_subscription_id"
    );
    const currentCreditCardId = get(
      this.props,
      "client.soothe_pass.credit_card_id"
    );

    if (!clientId || !subscriptionId || !currentCreditCardId) {
      this.setState({
        error: "Missing required information for plan update",
        showErrorModal: true,
      });
      return;
    }

    this.setState({ isUpdatingPlan: true });

    // Using the same updateSoothePassPaymentMethod function but updating the plan
    updateSoothePassPaymentMethod(
      clientId,
      subscriptionId,
      {
        credit_card_id: currentCreditCardId,
        city_id: get(this.props, "client.soothe_pass.city_id", ""),
        subscription_tier_id: get(selectedPlan, "plan.id"),
      },
      (response) => {
        this.setState({
          isUpdatingPlan: false,
          showSuccessModal: true,
          successMessage:
            "Your plan has been updated successfully. Changes will take effect on your next billing cycle.",
        });
        // Reload the page to refresh subscription data
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      },
      (error) => {
        this.setState({
          isUpdatingPlan: false,
          error: get(
            error,
            "response.data.errors.0.message",
            "Failed to update plan. Please try again."
          ),
          showErrorModal: true,
        });
      }
    );
  };

  closeSuccessModal = () => {
    this.setState({
      showSuccessModal: false,
      successMessage: "",
    });
    if (this.props.handleBack) {
      this.props.handleBack(true);
    }
  };

  closeErrorModal = () => {
    this.setState({
      showErrorModal: false,
      error: "",
    });
  };

  render() {
    const currentPlanId = get(
      this.props,
      "client.soothe_pass.subscription_tier_id"
    );

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          backgroundColor: "#FFFFFF",
          borderRadius: "16px",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            padding: "24px",
            backgroundColor: "#FFFFFF",
            borderRadius: "16px 16px 0px 0px",
          }}
        >
          <div style={{ position: "relative", height: "44px" }}>
            <button
              onClick={() => this.props.handleBack && this.props.handleBack()}
              style={{
                position: "absolute",
                left: "0px",
                top: "0px",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "14px",
                borderRadius: "48px",
                width: "24px",
                height: "44px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ArrowBack style={{ fontSize: "20px", color: "#323232" }} />
            </button>
          </div>

          {/* Title and Subtitle */}
          <div
            style={{ display: "flex", flexDirection: "column", gap: "2px 0px" }}
          >
            <div
              style={{
                fontFamily: "Poppins",
                fontWeight: "500",
                fontSize: "24px",
                lineHeight: "1.33em",
                color: "#000000",
                textAlign: "left",
              }}
            >
              Change your Plan
            </div>
            <div
              style={{
                fontFamily: "Poppins",
                fontWeight: "400",
                fontSize: "18px",
                lineHeight: "1.56em",
                color: "#545454",
                textAlign: "left",
              }}
            >
              Your new plan will begin on your next billing cycle.
            </div>
          </div>
        </div>

        {/* Plan Options */}
        <div
          style={{
            display: "flex",
            flexDirection: this.state.width < 768 ? "column" : "row",
            gap: "16px",
            padding: "24px 0px",
            alignItems: "stretch",
            flexWrap: "wrap",
            padding: this.state.width < 768 ? "24px" : "16px",
          }}
        >
          {this.state.loading ? (
            <div
              style={{ padding: "24px", textAlign: "center", color: "#545454" }}
            >
              Loading subscription plans...
            </div>
          ) : (
            this.state.subscriptionPlans.map((tier) => {
              const planId = get(tier, "plan.id");
              const isSelected = this.state.selectedPlan?.plan?.id === planId;
              const isCurrent = currentPlanId === planId;
              const planName = get(tier, "plan.name");
              const planDescription = get(tier, "plan.description");
              const points = get(tier, "points");
              const priceValue = get(tier, "price.value", "0");
              const priceDisplay = priceValue.toString().includes(",")
                ? priceValue
                : priceValue + ".00";
              const pricePeriod = get(tier, "price.per_period_brief");

              return (
                <div
                  key={planId}
                  onClick={() => !isCurrent && this.handlePlanSelect(tier)}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "24px",
                    backgroundColor: "#FFFFFF",
                    border: isSelected
                      ? "2px solid #F58266"
                      : isCurrent
                      ? "3px solid #5F637A"
                      : "1px solid #E2E2E2",
                    borderRadius: "8px",
                    cursor: isCurrent ? "default" : "pointer",
                    margin: this.state.width < 768 ? "0 24px" : "0",
                    flex: this.state.width < 768 ? "0 0 auto" : "1 1 0",
                    minWidth: this.state.width < 768 ? "auto" : "200px",
                    maxWidth: this.state.width < 768 ? "none" : "300px",
                    transition: "all 0.2s ease",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "stretch",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                        width: "100%",
                      }}
                    >
                      {/* Plan Name and Points */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "4px",
                        }}
                      >
                        <div
                          style={{
                            fontFamily: "Poppins",
                            fontWeight: "500",
                            fontSize: "14px",
                            lineHeight: "1.14em",
                            color: "#757575",
                            textAlign: "left",
                          }}
                        >
                          {planName}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "32px",
                          }}
                        >
                          <div
                            style={{
                              fontFamily: "Poppins",
                              fontWeight: "500",
                              fontSize: "22px",
                              lineHeight: "1.36em",
                              color: "#000000",
                              textAlign: "left",
                            }}
                          >
                            {points} points
                          </div>
                        </div>
                      </div>

                      {/* Description */}
                      <div
                        style={{
                          fontFamily: "Poppins",
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "1.43em",
                          color: "#545454",
                          textAlign: "left",
                          flex: "1",
                        }}
                      >
                        {planDescription}
                      </div>

                      {/* Price Section */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          gap: "16px",
                          justifyContent: "flex-end",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                        >
                          <div
                            style={{
                              fontFamily: "Poppins",
                              fontWeight: "500",
                              fontSize: "20px",
                              lineHeight: "1.4em",
                              color: "#000000",
                              textAlign: "right",
                            }}
                          >
                            {priceDisplay}
                          </div>
                          <div
                            style={{
                              fontFamily: "Poppins",
                              fontWeight: "400",
                              fontSize: "12px",
                              lineHeight: "1.67em",
                              color: "#545454",
                              textAlign: "right",
                            }}
                          >
                            {pricePeriod}
                          </div>
                        </div>
                      </div>

                      {/* Current Plan Indicator */}
                      {isCurrent && (
                        <div
                          style={{
                            fontFamily: "Poppins",
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#5F637A",
                            textAlign: "center",
                            marginTop: "8px",
                          }}
                        >
                          Current Plan
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* Docked Footer with Update Button */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            padding: "16px 0px",
            borderTop: "1px solid #E2E2E2",
            borderRadius: "0px 0px 16px 16px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "0px 16px",
            }}
          >
            <button
              onClick={this.handleUpdatePlan}
              disabled={
                !this.state.selectedPlan ||
                this.state.isUpdatingPlan ||
                get(this.state.selectedPlan, "plan.id") === currentPlanId
              }
              style={{
                width: "100%",
                maxWidth: "343px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                padding: "16px 20px",
                backgroundColor:
                  this.state.selectedPlan &&
                  !this.state.isUpdatingPlan &&
                  get(this.state.selectedPlan, "plan.id") !== currentPlanId
                    ? "#F58266"
                    : "#F6F6F6",
                color:
                  this.state.selectedPlan &&
                  !this.state.isUpdatingPlan &&
                  get(this.state.selectedPlan, "plan.id") !== currentPlanId
                    ? "#FFFFFF"
                    : "#AFAFAF",
                fontSize: "18px",
                fontWeight: "500",
                border: "none",
                borderRadius: "30px",
                cursor:
                  this.state.selectedPlan &&
                  !this.state.isUpdatingPlan &&
                  get(this.state.selectedPlan, "plan.id") !== currentPlanId
                    ? "pointer"
                    : "not-allowed",
                transition: "all 0.3s ease",
              }}
            >
              {this.state.isUpdatingPlan ? "Updating..." : "Update Membership"}
            </button>
          </div>
        </div>

        {/* Success Modal */}
        {this.state.showSuccessModal && (
          <SuccessModal
            isOpen={this.state.showSuccessModal}
            title="Success"
            subtitle={this.state.successMessage}
            action={this.closeSuccessModal}
            ctaText="Continue"
          />
        )}

        {/* Error Modal */}
        {this.state.showErrorModal && (
          <ErrorModal
            isOpen={this.state.showErrorModal}
            close={this.closeErrorModal}
          >
            <p>{this.state.error}</p>
          </ErrorModal>
        )}

        <LoadingOverlay showLoader={this.state.loading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  client: state.client,
});

export default connect(mapStateToProps)(ChangePlan);
